// Voice + search helpers for the Favourites list.
const FAV_RE = /\bmy\s+(?:\w+\s+)?favou?rites?\b|\bfavou?rites\b|\bmy\s+faves?\b/;
const NOT_NAV_RE = /\b(?:add|save|remove|delete|unfavou?rite|play|song|songs|music|playlist|movie|film)\b/;
const FAQ_RE = /^(?:what\s+(?:is|are|s)\s+favou?rites?|how\b|why\b|does\b|do\s+i\b|can\s+(?:i|other|anyone|people)\b|is\s+(?:it|my)\b|who\b)/;
const STRIP_RE = /\b(?:please|can|could|you|show|open|find|get|pull|bring|up|go|to|take|me|my|mine|our|the|a|an|all|of|in|on|from|for|list|whats?|what's|is|are|there|saved|favou?rites?|faves?|recipes?|cookbook|book|page|one)\b/g;

// "show me my favourites" → { term: "" }; "my favourite apple pie recipe" → { term: "apple pie" }; else null.
export function parseFavouritesQuery(txt) {
  const t = (txt || "").toLowerCase().replace(/[.?!,']+/g, " ").replace(/\s+/g, " ").trim();
  if (!FAV_RE.test(t) || NOT_NAV_RE.test(t) || FAQ_RE.test(t)) return null;
  return { term: t.replace(STRIP_RE, " ").split(/\s+/).filter((w) => w.length > 1).join(" ") };
}

export function matchFavourites(items, term) {
  const words = (term || "").toLowerCase().split(/\s+/).filter((w) => w.length > 1);
  if (!words.length) return items;
  return items.filter((it) => {
    const title = (it.title || it.recipe?.title || "").toLowerCase();
    return words.every((w) => title.includes(w.replace(/s$/, "")));
  });
}

export const favouritePath = (it, recipePath) => (it.kind === "historical"
  ? `/historical/${it.recipe?.slug || it.slug || it.item_id}`
  : recipePath(it.recipe || { recipe_id: it.item_id, title: it.title }));
